import type { TPlayerBase } from 'video.js'

import videojs from 'video.js'

const DEFAULT_VOLUME = 0.5
const DEFAULT_MOBILE_VOLUME = 1

/**
 * Returns the default volume for the current device
 * Should work in pair with volume bar show condition!
 * Volume bar is shown if !browser.TOUCH_ENABLED atm.
 */
export const getDefaultVolume = (): number => {
  const isMobile = videojs.browser.TOUCH_ENABLED

  if (isMobile) return DEFAULT_MOBILE_VOLUME

  return DEFAULT_VOLUME
}

export const SAFE_VOLUME = 0.25

export const LAST_VOLUME_KEY = 'pureya__last_volume'

/**
 * Code may read cache_ before
 * addon "persist-volume"applies overrides,
 * so we need to set correct values
 */
export function setCacheLastVolume(player: TPlayerBase): void {
  let volume = getDefaultVolume()
  try {
    let data = localStorage.getItem(LAST_VOLUME_KEY)
    if (!data) return
    const temp = Number(data)
    if (!isNaN(temp)) volume = temp
  } catch (ignore) {}

  if (player.cache_) player.cache_.volume = volume
}
